// Pure helpers for the Usage sheet (components/settings/UsageSheet.js), kept
// apart so they can be tested: the sheet's imports reach the Gemini SDK,
// which Jest can't load.

/** "41 s", "1 min 12 s". */
export const formatDuration = (ms) => {
  if (!Number.isFinite(ms) || ms <= 0) return null;
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  return s % 60 ? `${m} min ${s % 60} s` : `${m} min`;
};

/** A round top for the chart's axis: 1, 2, 2.5 or 5 times a power of ten. */
export const niceMax = (value) => {
  if (!(value > 0)) return 0.01;
  const power = 10 ** Math.floor(Math.log10(value));
  const step = [1, 2, 2.5, 5, 10].find((m) => m * power >= value);
  return step * power;
};

/** Change on last month's same days: "↓ 12% on Sep so far", or null. */
export const describeChange = (thisMonth, lastMonth, monthKey) => {
  if (!(lastMonth?.costToDate > 0)) return null;
  const pct = Math.round(((thisMonth.cost - lastMonth.costToDate) / lastMonth.costToDate) * 100);
  const [y, m] = String(monthKey || "").split("-").map(Number);
  const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const prev = y ? MONTHS[(m + 10) % 12] : "last month";
  if (pct === 0) return `Same as ${prev} so far`;
  return `${pct > 0 ? "↑" : "↓"} ${Math.abs(pct)}% on ${prev} so far`;
};

